import { REQUEST_TYPES } from "./request-types";

export const ROUTES = {
  home: "/",
  user_profile: "/profile",
  faq: "/faq",
  contacts: "/contact",
  unauthorized: "/unauthorized",
  request: {
    queue_basename: "/requests",
    user_queue: "/requests/user",
    supervisor_queue: "/requests/supervisor",
    additional_acceptor_queue: "/requests/additional-acceptor",
    get queue_with_parameter() {
      return `${this.queue_basename}/:key`;
    },
    new_expense: "/new_expense",
    meals_calendar_basename: "/request/meals-calendar",
    get meals_calendar_with_parameter() {
      return `${this.meals_calendar_basename}/:number`;
    },
    new_travel: "/new-travel",
    details_basename: "/request/details",
    get details_with_parameter() {
      return `${this.details_basename}/:number`;
    },
  },
  local_admin: {
    queue: "/local-admin",
    users_management_queue_basename: "/local-admin/users-management",
    users_management_queue_user: "/local-admin/users-management/users",
    get users_management_queue_with_parameter() {
      return `${this.users_management_queue_basename}/:key`;
    },
    requests_management_basename: "/local-admin/requests-management",
    requests_management_search: "/local-admin/requests-management/search",
    get requests_management_with_parameter() {
      return `${this.requests_management_basename}/:key`;
    },
    cards_management: "/local-admin/credit-cards/cards-management",
    card_statement_upload: "/local-admin/credit-cards/statement-upload",
    card_holders: "/local-admin/credit-cards/card-holders",
    costs_audit: "/local-admin/credit-cards/costs-audit",
    requests_history: "/local-admin/credit-cards/request-history",
    corporate_card_statement_upload:
      "/local-admin/corporate-cards/statement-upload",
    corporate_card_holders: "/local-admin/corporate-cards/card-holders",
    corporate_cards_management: "/local-admin/corporate-cards/cards-management",
  },
  accounts_payable: {
    panel: "/ap",
    queue_basename: "/ap/requests",
    queue_common: "/ap/requests/common",
    queue_employee: "/ap/requests/employee",
    get queue_with_parameter() {
      return `${this.queue_basename}/:key`;
    },
    sap_preview_basename: "/requests/preview",
    get sap_preview_with_parameter() {
      return `${this.sap_preview_basename}/:id`;
    },
    advance_payments_queue: "/ap/advance-payments",
  },
  cards: {
    corporate_cards_requests_queue_basename: "/corporate-requests",
    corporate_cards_requests_queue_user: "/corporate-requests/user",
    corporate_cards_requests_queue_supervisor: "/corporate-requests/supervisor",
    get corporate_cards_requests_queue_with_parameter() {
      return `${this.corporate_cards_requests_queue_basename}/:key`;
    },
    corporate_cards_request_details_basename: "/corporate-requests/details",
    get corporate_cards_request_details_with_parameter() {
      return `${this.corporate_cards_request_details_basename}/:number`;
    },
    card_requests_queue_basename: "/card-requests",
    card_requests_queue_user: "/card-requests/user",
    card_requests_queue_supervisor: "/card-requests/supervisor",
    card_requests_queue_additional_acceptor:
      "/card-requests/additional-acceptor",
    get card_requests_queue_with_parameter() {
      return `${this.card_requests_queue_basename}/:key`;
    },
    card_request_details_basename: "/card-requests/details",
    get card_request_details_with_parameter() {
      return `${this.card_request_details_basename}/:number`;
    },
  },
  cost_group: {
    queue: "/costgroup",
  },
  local_hr: {
    queue: "/localHR",
  },
  travel_acceptor: {
    queue: "/travel-acceptor",
  },
};

export const requestRoutesByType = {
  [REQUEST_TYPES.EXPENSE]: ROUTES.request.details_basename,
  [REQUEST_TYPES.TRAVEL]: ROUTES.request.details_basename,
  [REQUEST_TYPES.AMEX_BTA]: ROUTES.cards.card_request_details_basename,
  [REQUEST_TYPES.CREDIT_CARD]: ROUTES.cards.card_request_details_basename,
  [REQUEST_TYPES.EUROCARD]:
    ROUTES.cards.corporate_cards_request_details_basename,
};
